<div class="landing_bg">
<div id="bg">
  <img src="assets/images/login/construction.jpg" id="back1" alt="" />
</div>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-sm-5">
        <div class="panel login_panel">
          <div class="panel_top">
            <div class="logo col-md-8">
              <img src="assets/images/logo/CueTrans-logo.png" class="img-responsive" alt="logo" />
            </div>
          </div>
          <div class="logo2 col-md-12 clearfix">
         <div class=" logo-first">
            <img src="assets/images/logo/tl_logo.png" class="img-responsive" alt="logo2" />
          </div> 
          <div class="line-hgt"></div> 
          <div class="logo-second">
            <img src="assets/images/logo/tasnim.png" class="img-responsive" alt="logo2" />
          </div>
          </div>
          <div class="hd_text">
            <p>Logistics Management System</p>
          </div>
          <div style="padding-top:30px" class="panel-body">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
              <div style="margin-bottom: 25px" class="input-group">
                <label>User Name</label>
                <input id="float-input" type="text" class="ui-inputtext form-control" formControlName="strUserId"
                  pInputText placeholder="Username" />
                <span class="input-group-addon"><i class="fa fa-user-o" aria-hidden="true"></i></span>
              </div>

              <div style="margin-bottom: 25px" class="input-group">
                <label>Password</label>
                <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
                <input type="password" class="ui-inputtext form-control" formControlName="strPassword" pInputText
                  placeholder="Password" />
                <span class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></span>
              </div>
              <div class="row">

                
                <div class="col-sm-6"><a href="#" class="cursor-pointer" (click)=onResetPassword()>Forgot
                    password?</a></div>

              </div>

              <div class="form-group sub_btn">
                <div class="col-sm-9 controls">
                  <button type="submit" class="btn btn-primary">Sign In</button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- <div class="landing_block">
    <div class="landing_txt">
      <h2>Welcome to</h2>
      <h1>CueTrans</h1>
      <p>CueTrans Suite, a proven suite of logistics solutions, helps plan, optimize and manage logistics operations,
        standard and out-sized dimension project cargo transportation, materials and inventory management whilst
        placing the utmost emphasis on Health, Safety, Security and Environmental (HSSE) and sustainability with a
        commitment to deliver exemplary operational, safety and commercial performance.</p>
    </div>
  </div> -->

  <!--START FOOTER-->
  <footer>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <p>Copyright &copy; 2019. Bahwan CyberTek. All Right Reserved.</p>
        </div>
        <div class="col-md-6">
          <p class="pwr">Powered by <img alt="logo" width="100px" class="img-responsive" src="assets/images/logo/CueTrans-logo.png"></p>
        </div>
      </div>
    </div>
  </footer>
  <!--END FOOTER-->

</div>
<p-confirmDialog [style]="{width: '40vw'}"></p-confirmDialog>